import React, { ReactNode } from 'react';
import {
  ScrollView,
  View,
  ScrollViewProps,
  ViewStyle,
  StyleProp,
} from 'react-native';
import { isWeb } from '../../utils/platformUtils';

type Props = ScrollViewProps & {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
  contentContainerStyle?: StyleProp<ViewStyle>;
};

/**
 * On web, page scroll is handled by WebPage / WebDesktopLayout — this renders a plain View.
 * On native, behaves as a normal ScrollView.
 */
const PageScroll = ({ children, style, contentContainerStyle, ...rest }: Props) => {
  if (isWeb) {
    return (
      <View style={[style, contentContainerStyle]}>
        {children}
      </View>
    );
  }

  return (
    <ScrollView style={style} contentContainerStyle={contentContainerStyle} {...rest}>
      {children}
    </ScrollView>
  );
};

export default PageScroll;
